<template>
  <reg-grid
    :viewName='name'
    :keyExpr='key'
    :custom-context-menu='customContextMenu'
    :dbSchema='matview_schema'
    :dbSource='matview'
    :cardName='cardName'
    :toolbarMeta='toolbarMeta'
    :selection-mode='settings?.selectionMode'
    apiGetList='kv-customer-list/data/get'
    :toolbar-show='settings?.toolbarShow !== undefined ? settings?.toolbarShow : true'
    :filterPanelShow='settings?.filterPanelShow !== undefined ? settings?.filterPanelShow : true'
    :total-count-selected-show='settings?.totalCountSelectedShow !== undefined ? settings?.totalCountSelectedShow : true'
    :filter-row='settings?.filterRow !== undefined ? settings?.filterRow : true'
    :findText='findText'
  >
  </reg-grid>
</template>

<script>
import RegGrid from '@/virtual/reg-grid.vue';
import { useRouter } from 'vue-router';

export default {
  name: 'view-kv-customer',
  props: {
    settings: {
      type: Object,
      default: () => {
        return {
          toolbarShow: true,
          filterPanelShow: true,
          selectionMode: 'multiple',
          totalCountSelectedShow: true,
          filterRow: { visible: true },
        };
      },
    },
    findText: {
      type: String,
      default: () => {
        return '';
      },
    },
  },
  setup() {
    const router = useRouter();
    return {
      name: 'view-kv-customer',
      matview_schema: 'payer',
      matview: 'mvi_customer',
      key: 'kodp',
      cardName: 'counteragent-card-view',
      toolbarMeta: {
        columnChooserButton: {
          visible: true,
        },
      },
      customContextMenu: [
        {
          name: 'gotoCard2',
          text: 'Посмотреть карточку',
          visible: true,
          onItemClick: e => {
            const id = e.itemData.rowData.key;
            router.push({
              name: 'counteragent-card-view',
              params: { id },
            });
          },
        },
      ],
    };
  },
  components: {
    RegGrid,
  },
};
</script>

<style scoped></style>
